export default "__VITE_ASSET__3cdeaf13__"